module.exports = __webpack_public_path__ + "media/application/images/cyber-forum/external-f7f0214223bb915293bea57e07e53e43.svg";